import { generateEndpoint } from "@/utils/utils";
import type { PaginatedResponse } from "@/v2/queries/types";
import { apiClientJSON } from "../apiClient";

export interface Dock {
  id: number;
  code: string;
  status: string;
  type?: string;
  stationId: number;
  stationName?: string;
  station?: {
    code: string;
    name?: string;
    city?: {
      name: string;
    };
  };
  vehicleId?: number;
  vehicleCode?: string;
  vehicle?: {
    code: string;
    name?: string;
  };
  fault?: string;
  lastErrorCode?: string;
  lastSeen?: string;
}

export interface DockListParams {
  page?: number;
  search?: string;
  sort?: string;
  filter?: string;
  pageSize?: number;
}

export const getDocksAPI = (
  params: DockListParams = {}
): Promise<PaginatedResponse<Dock>> => {
  const {
    page = 0,
    search = "",
    sort = "",
    filter = "",
    pageSize = 10,
  } = params;
  const endpoint = generateEndpoint(
    `/station-service/dashboard/docks?size=${pageSize}`,
    page,
    search,
    sort,
    filter
  );
  return apiClientJSON.get(endpoint).then((r) => r.data);
};

export const getDockStatusesAPI = (): Promise<string[]> => {
  return apiClientJSON
    .get("/station-service/dashboard/docks/statuses")
    .then((r) => r.data);
};

export const unlockDockAPI = (id: number): Promise<void> => {
  return apiClientJSON
    .post(`/station-service/dashboard/docks/${id}/unlock`)
    .then((r) => r.data);
};

export const updateDockAPI = (
  id: number,
  body: Partial<Dock>
): Promise<Dock> => {
  return apiClientJSON
    .put(`/station-service/dashboard/docks/${id}`, body)
    .then((r) => r.data);
};

export const clearDockFaultAPI = (id: number): Promise<void> => {
  return apiClientJSON
    .post(`/station-service/dashboard/docks/${id}/clear-fault`)
    .then((r) => r.data);
};
